import React, { useEffect, useState } from 'react';
import { useLocation, useParams, useNavigate } from 'react-router-dom';
import { get } from 'lodash';
import { useSelector, useDispatch } from 'react-redux';

import { Button } from '../../components/Field';
import { scrollToTop } from '../../helpers/animation';
import { makeProfileData } from '../../actions/storage';
import Title from '../../components/Title';
import Spacer from '../../components/Spacer';
import Widget from '../Widgets';
import Loader from "../Shared/Loader";
import Editor from '../../components/Editor';
import NoMatch from '../../components/NoMatch';
import MetaTag from '../../components/MetaTag';
import AsyncGet from '../../components/AsyncGet';
import DialogBox from '../../components/DialogBox';

import style from "./style.module.css";

const Page = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const Params = useParams();
    const { pathname } = useLocation();
    let targetPath = `/page${pathname === "/" ? "/home" : pathname}`;
    if (pathname.includes("/reset-password/")) {
        if (get(Params, 'hash')) {
            targetPath = "/page/reset-password";
        }
    }
    if (pathname.includes("/setup-password/")) {
        if (get(Params, 'hash')) {
            targetPath = "/page/setup-password";
        }
    }
    if (pathname.includes("/register/")) {
        if (get(Params, 'plan')) {
            targetPath = "/page/register";
        }
    }
    if (pathname.includes("/redeem/")) {
        if (get(Params, 'hash')) {
            targetPath = "/page/redeem";
        }
    }
    if (pathname.includes("/reactivation/")) {
        if (get(Params, 'hash')) {
            targetPath = "/page/reactivation";
        }
    }
    if (pathname.includes("/article/")) {
        targetPath = pathname;
    }
    if (pathname.includes("/book/")) {
        targetPath = pathname;
    }
    if (pathname.includes("/series/") || pathname.includes("/theme/") || pathname.includes("/category/") || pathname.includes("/tag/")) {
        targetPath = "/categorisation" + pathname;
    }
    const userProfile = useSelector((state) => state.storage.data);
    const [showPopup, setPopup] = useState(false);
    const [firstName, setFirstName] = useState(false);

    useEffect(() => {
        scrollToTop()
    }, [pathname])

    useEffect(() => {
        if (get(userProfile, "initial_login") === 1 && showPopup === false) {
            setPopup("welcomePopup");
            setFirstName(get(userProfile, "first_name"));
        }
    }, [userProfile, showPopup]);

    const gotoProfile = () => {
        setPopup(false);
        navigate('/profile');
    }

    return (
        <>
            <AsyncGet
                key={targetPath}
                url={targetPath}
                permissionText={false}
                loadOnMount={true}
                showToastOnError={false}
                render={({ fetching, loaded, data }) => {
                    const widgets = data['widgets'] || false;
                    return (
                        <>
                            {
                                loaded === false && fetching === true && (
                                    <Loader />
                                )
                            }
                            {
                                loaded === true && fetching === false && widgets === false && (
                                    <NoMatch background={true} />
                                )
                            }
                            {
                                loaded === true && fetching === false && widgets !== false && widgets.length > 0 && widgets.map((wdata, index) => (
                                    <React.Fragment key={`widget_item_${index}`}>
                                        <MetaTag {...get(data, 'meta_tag')} />
                                        <Widget data={{ index, ...wdata }} pageData={data} key={`widget_${index}`} />
                                    </React.Fragment>
                                ))
                            }
                        </>
                    )
                }}
            />
            {
                showPopup === "welcomePopup" && (
                    <AsyncGet
                        url={`/account/initial-setup`}
                        method="put"
                        loadOnMount={true}
                        permissionText={"Initial Setup"}
                        onFetch={({ data }) => {
                            if (get(data, 'id')) {
                                dispatch(makeProfileData(data))
                            }
                        }}
                        render={({ fetching }) => {
                            return (
                                <DialogBox
                                    onClose={() => setPopup(false)}
                                    hasCloseIcon={false}
                                    title={false}
                                    className={`${style.welcomePopup}`}
                                    render={({ closeDialog }) => {
                                        return (
                                            <div className={`${style.popupArea}`}>
                                                <div className={style.popupWrap}>
                                                    <div className={style.sectionRow}>
                                                        <div className={style.sectionHeader}>
                                                            <Title tag="h2" transform={"uppercase"} className={"fontTeko"}>Welcome {firstName}</Title>
                                                        </div>
                                                        <div className={style.sectionBody}>
                                                            <div className={style.sectionBody}>
                                                                <Editor text={"<b>You’re in – nice one!</b> First mission: click your profile (top right), upload a lovely pic, and start exploring. Like something? Hit save. To find it again, head back to your profile and scroll down."} />
                                                                <Spacer />
                                                                <Editor text={"Oh, and check your inbox – we’ve sent you a <b>welcome discount</b> for the shop. Go on, treat yourself."} />
                                                                <Spacer />
                                                                <Editor text={"<b>Job done. Stand easy.</b>"} />
                                                                <Spacer />
                                                                <Editor text={"Cheers,<br/>Jim, Al and the WW2 Headquarters crew"} />
                                                            </div>
                                                        </div>
                                                        <div className={style.sectionFooter}>
                                                            <Button onClick={closeDialog} color={"buttonPrimary"} label={"LETS BEGIN!"} />
                                                            <Button onClick={gotoProfile} color={"buttonPrimaryWithOutBg"} label={"COMPLETE YOUR PROFILE"} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    }}
                                />
                            )
                        }}
                    />
                )
            }
        </>
    )
}

export default Page;